import { flow, types } from 'mobx-state-tree';
import cookieUtils from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { isNextServer } from '@/intl-jdi-common-ssr/utils/uaParser';
import { getCart } from '@/apis/header/header.api';
import { CartData } from '../apis/cart/cart.interface';
import { withSetPropAction } from '@/models/helpers/withSetPropAction';

export const CartNumStore = types
  .model('CartNumStore')
  .props({
    loading: false, // 新增加载标记
    cartNum: types.maybe(types.number), //购物车数量
  })
  .actions(withSetPropAction)
  .actions((self) => {
    // 公共逻辑：解析接口结果
    function parseCartNum(data: CartData) {
      const subtotal = data?.data?.subtotal as any;
      if (subtotal) {
        const productNum = subtotal?.info?.['HJM-D#subtotal&number']?.productNum || '';
        return Number(productNum);
      }
      return 0;
    }

    return {
      /**
       * 统一获取购物车数量
       * @param force 是否强制刷新
       */
      fetchCartNum: flow(function* (force = false) {
        if (self.loading) return;

        // 只有在客户端的时候才去更新购物车数量，服务端在store里不执行
        if (isNextServer()) {
          return;
        }
        // 如果已有数据且不强制刷新 → 直接返回
        if (self.cartNum && !force) {
          return;
        }

        self.loading = true;
        try {
          const res = yield getCart({
            verticalTag: 'cn_ybxt_b2c',
            omittedDetail: true,
            cartuuid: cookieUtils.getCookie('VISITOR_UUID'),
            userActionId: 'getCart',
          });
          self.cartNum = parseCartNum(res?.data);
        } finally {
          self.loading = false;
        }
      }),
      /**
       * 将 trade_cart_modifyItem、trade_cart_addItem 购物车修改接口调用后的返回传进来，更新最新的购物车数量
       */
      updateCartNum(data: CartData) {
        self.cartNum = parseCartNum(data);
      },
      /**
       * 直接更新购物车数字
       */
      setCartNum(newNum: number) {
        self.cartNum = newNum;
      },
    };
  })
  .views((self) => ({
    // 用于是否展示购物车数字的判断
    get isCartNumValid() {
      return !!(self.cartNum && self.cartNum > 0);
    },
    // 用于购物车数量实际展示，0的情况若无需展示，可先用 isCartNumValid 判断
    get displayCartNum() {
      if (!self.cartNum || self.cartNum < 0) {
        return '0';
      } else if (self.cartNum > 99) {
        return '99+';
      }
      return self.cartNum.toString();
    },
  }));
